export default __webpack_public_path__ + "static/media/cleanProducts.dc1f5cd0.svg";